import { call, put, takeLatest } from 'redux-saga/effects';

import { type ILicenseSearchResult } from '../../Licenses/store/types';

import { getLicenses } from '../../Licenses/services/licensesApiService';

import { type SearchResult } from '../../../@types/serviceTypes';

import { setChildren, setChildrenLoading } from './slices';
import { toasterValidationError } from '../../../helpers';
import * as actions from './actions';

function* getChildrenSaga({ payload }: ReturnType<typeof actions.getChildren>) {
  try {
    yield put(setChildrenLoading(true));
    const { data } = yield call(getLicenses, payload);
    yield put(setChildren(data as SearchResult<ILicenseSearchResult>));
  } catch (err) {
    toasterValidationError(err);
  } finally {
    yield put(setChildrenLoading(false));
  }
}

export default function* watchChildrenSaga() {
  yield takeLatest(actions.getChildren, getChildrenSaga);
}
